
riot.tag2('measure-weight', '  <catalog object="MeasureWeight" cols="{cols}" reload="true" add="{add}" remove="{remove}" dblclick="{measureOpen}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="code">{row.code}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="designation">{row.designation}</datatable-cell>\n      <datatable-cell name="precision">{row.precision}</datatable-cell>\n      <datatable-cell name="value">{row.value}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'MeasureWeight';

self.cols = [{ name: 'id', value: '#' }, { name: 'code', value: 'Код ОКЕИ' }, { name: 'name', value: 'Наименование' }, { name: 'designation', value: 'Обозначение' }, { name: 'precision', value: 'Точность' }, { name: 'value', value: 'Мера' }];

observable.on('measurement-reload', function () {
     self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/settings/measurements/measure-weight.tag